/* ============================================================================
   Petpal homepage JS — ported from "Petpal Home.dc.html" (applyResponsive + reveal + IG feed).
   Header/logo/nav/footer responsive logic lives in pp-theme.js (global) — NOT here.
   This file owns ONLY the homepage body: hero peeking pets + heart scatter (LOCKED),
   the body responsive grids/splits, scroll-reveal, review filter, and the live IG feed.

   🔒 LOCKED HERO-PET PROPORTIONS — signed off 2026-07-04. DO NOT ALTER without approval.
      See PET-HERO-LOCKED-SPEC.md. Golden crest: mob VP=39 · band cBase=31 · desktop cBase=52
      (·0.131 GBOTT). Side-pet grip: dachVP=10 (both bands) · catVP 32 desktop / 24 band.
      Values + formulas below are copied verbatim from the render's applyResponsive().
   ========================================================================== */
(function () {
  function ready(fn){ document.readyState !== 'loading' ? fn() : document.addEventListener('DOMContentLoaded', fn); }
  function icons(){ if (window.lucide && window.lucide.createIcons) { try { window.lucide.createIcons(); } catch(e){} } }

  function applyResponsive() {
    var root = document;
    var w = window.innerWidth;
    var grids = function (sel, cols) { var el = root.querySelector(sel); if (el) el.style.gridTemplateColumns = cols; };
    var mob = w <= 640, tab = w <= 960;

    // --- body responsive grids (header + footer grids are handled elsewhere) ---
    grids('[data-iggrid]', mob ? 'repeat(2,1fr)' : (tab ? 'repeat(3,1fr)' : 'repeat(6,1fr)'));
    grids('[data-pgrid]', mob ? '1fr 1fr' : (tab ? 'repeat(2,1fr)' : 'repeat(4,1fr)'));
    grids('[data-concerns]', mob ? '1fr 1fr' : (tab ? 'repeat(3,1fr)' : 'repeat(4,1fr)'));
    grids('[data-ings]', tab ? 'repeat(2,1fr)' : 'repeat(4,1fr)');
    grids('[data-stats]', mob ? '1fr 1fr' : 'repeat(4,1fr)');
    grids('[data-rgrid]', tab ? '1fr' : 'repeat(3,1fr)');
    root.querySelectorAll('[data-split]').forEach(function (el) { el.style.gridTemplateColumns = tab ? '1fr' : el.getAttribute('data-cols') || ''; });

    var hearts = root.querySelector('[data-hearts]');
    if (hearts) {
      hearts.style.display = 'block';                          // always show the heart treats — incl. iPhone, with the pup
      var hi = hearts.querySelectorAll('img');
      if (mob && hi.length >= 4) {                             // mobile: scatter them around the golden pup
        var P = [['53%','1%','auto','78px'],   // left of the pup
                 ['48%','auto','1%','66px'],   // right of the pup
                 ['9%','2%','auto','56px'],    // top-left by the headline
                 ['21%','auto','2%','50px']];  // right by the subhead
        hi.forEach(function (im, i) { if (P[i]) { im.style.top = P[i][0]; im.style.left = P[i][1]; im.style.right = P[i][2]; im.style.width = P[i][3]; } });
      } else if (hi.length >= 4) {
        // restore desktop scatter — the defaults live in INLINE style, so set them back explicitly (clearing them = giant intrinsic-size hearts)
        var D = [['11%','6%','auto','clamp(84px,9vw,132px)'],
                 ['17%','auto','6.5%','clamp(70px,7.5vw,110px)'],
                 ['52%','12%','auto','clamp(58px,6vw,86px)'],
                 ['56%','auto','11%','clamp(52px,5.5vw,78px)']];
        hi.forEach(function (im, i) { if (D[i]) { im.style.top = D[i][0]; im.style.left = D[i][1]; im.style.right = D[i][2]; im.style.width = D[i][3]; } });
      }
    }

    var contentDiv = root.querySelector('[data-herocontent]');   // headline/subhead div holding the reserved space
    var hbar = root.querySelector('[data-herobar]');
    var peeks = root.querySelectorAll('[data-peekwrap]');
    // --- hero bar: mobile shows only the navy CTA card (full width); wider shows all 3 panels ---
    if (hbar) {
      var panels0 = hbar.children;                            // [0]=12,400+ tan · [1]=navy CTA · [2]=4.8 tan
      hbar.style.flexDirection = 'row'; hbar.style.alignItems = 'flex-end';
      if (panels0[0]) panels0[0].style.display = mob ? 'none' : 'flex';
      if (panels0[2]) panels0[2].style.display = mob ? 'none' : 'flex';
      if (panels0[1]) { panels0[1].style.margin = mob ? '0' : '0 -16px'; panels0[1].style.flex = mob ? '1' : '1.12'; }
    }
    // ══════════════════════════════════════════════════════════════════════════════════════
    // 🔒 LOCKED HERO-PET PROPORTIONS — signed off 2026-07-04. DO NOT ALTER without approval.
    //    Exact per-breakpoint values + Shopify/Liquid port rules: ./PET-HERO-LOCKED-SPEC.md
    //    Golden crest:  mob VP=39 · band cBase=31 · desktop cBase=52  (·0.131 GBOTT)
    //    Side-pet grip: dachVP=10 (both bands) · catVP 32 desktop / 24 band  (measure-then-seat)
    // ══════════════════════════════════════════════════════════════════════════════════════
    // --- peeking pets: sized & spaced analytically (square images: height === width) so they never collide OR leave a void ---
    if (peeks.length >= 3) {
      var sidePetHide = w <= 1040;                             // side pets follow their stat cards
      peeks[0].style.display = sidePetHide ? 'none' : 'block'; // dachshund (left)
      peeks[2].style.display = sidePetHide ? 'none' : 'block'; // cat (right)
      // side pets (dachshund left, cat right) are seated AFTER the golden sets paddingBottom (below) — measured, so they rest on the tan bar at EVERY width
      // golden (center) — seat the pup on the card using the VISIBLE dog, not the PNG's padded box
      var TOPT = 0.186, BOTT = 0.113;   // transparent margin baked into the golden PNG (top / bottom)
      var gwMin, gwVw, gwMax, crest, gap, gwPx;
      if (mob) {
        gwMin = 224; gwVw = 60; gwMax = 290;                    // bigger pup so it anchors the phone hero
        gwPx = Math.round(Math.max(gwMin, Math.min(gwVw / 100 * w, gwMax)));
        var VH = 20, VP = 39;                                   // visible-head gap below subhead · visible-paw overlap into banner (+3px = down ~1%)
        crest = Math.round(VP + BOTT * gwPx);
        var g = peeks[1];
        g.style.display = 'block'; g.style.width = gwPx + 'px';
        g.style.bottom = 'calc(100% - ' + crest + 'px)';
        if (contentDiv) contentDiv.style.paddingBottom = Math.round(VH - VP + (1 - TOPT - BOTT) * gwPx) + 'px';
      } else {
        // golden: seat by its VISIBLE paws (like the side pets) so it drapes the navy by a CONSTANT amount at EVERY width.
        // The old fixed crest (54 below 1240px) let the overlap fall to ~18px as the pup scaled — reads as a gap/float.
        var GBOTT = 0.131;                                      // transparent space below the golden's paws in the PNG
        var cBase;
        if (w < 1240) { gwMin = 210; gwVw = 22; gwMax = 300; gap = 52; cBase = 31; }  // tablet/laptop — raised ~7% (21px) so the small clamped pup shows as much dog as desktop
        else          { gwMin = 280; gwVw = 30; gwMax = 470; gap = 56; cBase = 52; }  // desktop full drape (unchanged)
        gwPx = Math.round(Math.max(gwMin, Math.min(gwVw / 100 * w, gwMax)));
        crest = Math.round(cBase + GBOTT * gwPx);              // paws grip cBase px into the navy (desktop 52 unchanged; tablet band 31)
        var g2 = peeks[1];
        g2.style.display = 'block'; g2.style.width = gwPx + 'px';
        g2.style.bottom = 'calc(100% - ' + crest + 'px)';
        if (contentDiv) contentDiv.style.paddingBottom = (gwPx - crest + gap) + 'px';
      }
      // --- SIDE PETS: seat visible paws on the tan stat panels (measured; transparent-padding-aware) so there's NEVER a gap at any width ---
      if (!sidePetHide && hbar && peeks[0] && peeks[2]) {
        var panels = hbar.children;
        var wrap = peeks[0].parentElement;
        // side pets = SAME size; both seated by their paws on the tan bar (paws align). The cat PNG is framed taller,
        // so its head naturally sits a bit higher than the dachshund's — an intentional, balanced peek.
        var dachW = peeks[0].getBoundingClientRect().width;
        peeks[2].style.width = Math.round(dachW) + 'px';                        // cat matches dachshund width
        var seatSide = function (petEl, panelEl, transBottom, VP2) {
          if (!petEl || !panelEl) return;
          var wrapTop = wrap.getBoundingClientRect().top;
          var pw = petEl.getBoundingClientRect().width;             // square PNG → visible-paw offset from box bottom = transBottom * width
          var panelTop = panelEl.getBoundingClientRect().top;
          var cr = (panelTop - wrapTop) + VP2 + transBottom * pw;    // makes visible paws land VP px below the tan panel's top edge
          petEl.style.bottom = 'calc(100% - ' + Math.round(cr) + 'px)';
        };
        var dachVP = 10;                                             // dachshund grip — raised another 5% (15px): 25→10, both bands (paws near panel top now)
        var catVP  = (w >= 1240) ? 32 : 24;                          // cat grip — desktop 32; 1041–1240 band 24 (down 1% from 21)
        seatSide(peeks[0], panels[0], 0.286, dachVP);                // dachshund PNG: solid paws at 71.4%
        seatSide(peeks[2], panels[2], 0.153, catVP);                 // cat PNG: solid paws at 84.7%
      }
    }
  }

  function setupReveal() {
    var root = document;
    var els = root.querySelectorAll('[data-reveal]');
    if (!('IntersectionObserver' in window)) return;
    els.forEach(function (el) { el.style.opacity = '0'; el.style.transform = 'translateY(26px)'; el.style.transition = 'opacity .7s ease, transform .7s ease'; });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.style.opacity = '1'; en.target.style.transform = 'none'; io.unobserve(en.target); } });
    }, { threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---- reviews filter (ports the .dc setState filter — client-only) ---- */
  function setupReviewFilter() {
    var root = document;
    var btns = root.querySelectorAll('[data-revfilter]');
    var cards = root.querySelectorAll('[data-revcat]');
    if (!btns.length || !cards.length) return;
    var onStyle = 'background:#001f36;color:#F5F3EE;border:1.5px solid #001f36;border-radius:99px;padding:9px 18px;font-family:\'Hanken Grotesk\',sans-serif;font-size:13px;font-weight:600;cursor:pointer;transition:.18s;display:inline-flex;align-items:center;gap:8px;box-shadow:0 6px 16px rgba(0,31,54,.18)';
    var offStyle = 'background:#FFFDF9;color:#5b6b7a;border:1.5px solid #e7ded0;border-radius:99px;padding:9px 18px;font-family:\'Hanken Grotesk\',sans-serif;font-size:13px;font-weight:600;cursor:pointer;transition:.18s;display:inline-flex;align-items:center;gap:8px;box-shadow:0 1px 2px rgba(0,31,54,.05)';
    function apply(filter) {
      btns.forEach(function (b) {
        var on = b.getAttribute('data-revfilter') === filter;
        b.setAttribute('style', on ? onStyle : offStyle);
        var ic = b.querySelector('.lic');
        if (ic) ic.style.color = on ? '#E7CF95' : '#C29A52';
      });
      cards.forEach(function (c) {
        c.style.display = (filter === 'All' || c.getAttribute('data-revcat') === filter) ? '' : 'none';
      });
      icons();
    }
    btns.forEach(function (b) { b.addEventListener('click', function () { apply(b.getAttribute('data-revfilter')); }); });
  }

  /* ---- LIVE @petpalfoods feed via Behold JSON → rendered into the site's own grid; auto-updates each load ---- */
  function loadInstagram() {
    var grid = document.querySelector('[data-iggrid]');
    if (!grid) return;
    fetch('https://feeds.behold.so/ncjauuQ14gsUR8GRetzS').then(function (r) { return r.json(); }).then(function (d) {
      var fmt = function (n) { return n >= 1000 ? (n / 1000).toFixed(1).replace(/\.0$/, '') + 'k' : ('' + (n || 0)); };
      var posts = (d.posts || []).slice(0, 6).map(function (p) {
        var s = (p.sizes && (p.sizes.medium || p.sizes.small || p.sizes.large)) || {};
        return { src: s.mediaUrl || p.thumbnailUrl || p.mediaUrl, alt: (p.caption || 'petpalfoods on Instagram').slice(0, 80), likes: fmt(p.likeCount), href: p.permalink };
      }).filter(function (p) { return p.src; });
      if (!posts.length) return;
      var igSvg = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line></svg>';
      grid.innerHTML = posts.map(function (ig) {
        var href = ig.href || 'https://www.instagram.com/petpalfoods/';
        return '<a href="' + href + '" target="_blank" rel="noopener" class="ig-tile" style="position:relative;display:block;aspect-ratio:1;border-radius:16px;overflow:hidden;background:#EDE7DB">'
          + '<img src="' + ig.src + '" alt="' + (ig.alt || '').replace(/"/g, '&quot;') + '" style="width:100%;height:100%;object-fit:cover;display:block" loading="lazy">'
          + '<div class="ig-ov" style="position:absolute;inset:0;background:rgba(0,31,54,.42);display:flex;flex-direction:column;align-items:center;justify-content:center;gap:8px;color:#fff">'
          + '<span class="lic" style="width:26px;height:26px">' + igSvg + '</span>'
          + '<span style="display:inline-flex;align-items:center;gap:6px;font-size:13px;font-weight:600"><span class="lic" style="width:15px;height:15px"><i data-lucide="heart"></i></span>' + ig.likes + '</span>'
          + '</div></a>';
      }).join('');
      icons();
    }).catch(function () {});
  }

  ready(function () {
    applyResponsive();
    setupReveal();
    setupReviewFilter();
    loadInstagram();
    icons();

    var onResize = function () { applyResponsive(); };
    window.addEventListener('resize', onResize);
    // re-seat the peeking pets once fonts/images settle — panel heights shift, and the pets are seated by MEASURING those panels
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { applyResponsive(); });
    window.addEventListener('load', onResize);
    [150, 500, 1100].forEach(function (t) { setTimeout(function () { applyResponsive(); }, t); });
  });
})();
